




























































































import {Component, Vue} from 'vue-property-decorator';
import JdsNavigatorFullPageLayout from "@/design-system/patterns/Navigator/JdsNavigatorFullPageLayout.vue"
import JdsNavigator from "@/design-system/patterns/Navigator/JdsNavigator.vue"
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdsNavigatorChildItem from "@/design-system/patterns/Navigator/JdsNavigatorChildItem.vue"
import JdsNavigatorLayout from "@/design-system/patterns/Navigator/JdsNavigatorLayout.vue"
import JdsNavigatorItemGroup from "@/design-system/patterns/Navigator/JdsNavigatorItemGroup.vue"
import JdsNavigatorBadge from "@/design-system/patterns/Navigator/JdsNavigatorBadge.vue"
import JdsNavigatorItem from "@/design-system/patterns/Navigator/JdsNavigatorItem.vue"
import JdiStatus from "@/components/JdiStatus.vue"
import JdiContent from "@/components/JdiContent.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsCandidateBubble from "@/design-system/constructs/CandidateBubble/JdsCandidateBubble.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"
import JdsNavigatorHeading from "@/design-system/patterns/Navigator/JdsNavigatorHeading.vue"
import JdsNavigatorBackLink from "@/design-system/patterns/Navigator/JdsNavigatorBackLink.vue"


@Component({
    components: {
        JdsNavigatorItemGroup,
        JdsNavigatorBackLink,
        JdsNavigatorHeading,
        JdsGlyph,
        JdsCandidateBubble, JdsNavigator, JdsNavigatorFullPageLayout,
        JdsIcon,
        JdsNavigatorChildItem,
        JdsNavigatorLayout,
        JdsNavigatorBadge, JdsNavigatorItem, JdiStatus, JdiContent, JdiPreview,
    }
})
export default class JdpSingleJob extends Vue {

    nav(path: string) {
        return {
            name: 'docs.patterns.navigator.dummy',
            params: {dummy: path}
        }
    }
}
